//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: [],
    data () {
        return {
            tableData: [],
            pgData: {},

            dialogVisible: false,
            dialogTitle: '',

            formSearch: {
                rowguid: ''
            },

            auditForm:{
                paystatus:"",
                reason:"",
                applyno:""
            },

            paystatusOption:[
                {value: '0',label: '未付款'},
                {value: '1',label: '已付款'},
                {value: '2',label: '待核实'},
                {value: '3',label: '付款失败'},
                {value: '4',label: '已退款'},
                {value: '5',label: '退款中'},
            ]
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        }
    },
    methods: {
        cancle(){
            this.dialogVisible = false;
        },
        afterSend(){
            this.dialogVisible = false;
        },
        verifyHandler(row) {
            this.dialogTitle = '审核';
            this.auditForm.applyno = row.applyno;
            this.dialogVisible = true;
        },
        refundHandler(row){
            var that = this;
            this.$confirm('确认退款吗？','提示',{
                confirmButtonText:"确认",
                cancelButtonText:"取消",
            }).then(()=>{
                this.$ajax({
                    type: 'post',
                    url: that.getStore('fy') + '/pay/refund',
                    data: {
                        applyno:row.applyno
                    },
                    callback: (data) => {
                        ShowMsg.call(this, '退款成功','success');
                        that.reloadHandler();
                    },
                });
            }).catch(()=>{
                this.$message({
                    type: 'info',
                    message: '已取消退款'
                });       
            })
        },

        reloadHandler() {
            this.$refs.page.reload();
        },
    },
    mounted: function() {

    }
}
